(() => {
  // Mindestbestellwert 5,90 EUR zaehlt VOR Rabatten (original_total_price), Okt 2026.
  // Die Liquid-Templates sperren den Button anhand des Preises nach Rabatt; dieses Skript
  // korrigiert das nach jedem Laden und jedem Neuaufbau des Warenkorbs.
  const MINIMUM = 590;
  const applyMinimum = (cart) => {
    if (!cart) return;
    const total = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
    if (typeof total !== 'number') return;
    const belowMinimum = cart.item_count === 0 || total < MINIMUM;
    for (const id of ['checkout', 'CartDrawer-Checkout']) {
      const button = document.getElementById(id);
      if (button && button.disabled !== belowMinimum) button.disabled = belowMinimum;
    }
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(element => {
      if (element.hidden !== belowMinimum) element.hidden = belowMinimum;
    });
    document.querySelectorAll('.pf-cart-minimum').forEach(element => {
      if (!belowMinimum) element.hidden = true;
    });
  };
  const refresh = () => fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.ok ? response.json() : null)
    .then(applyMinimum).catch(() => {});
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { applyMinimum(event.cartData); setTimeout(refresh, 400); });
  }
  let timer;
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(refresh, 250); });
  const watch = () => {
    document.querySelectorAll('cart-drawer, #main-cart-footer, #main-cart-items').forEach(element => {
      observer.observe(element, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  refresh();
})();